import React, { useEffect, useState } from "react";
import { Image, Pagination, Spin, Select, Card, Layout, Button } from "antd";
import axios from "axios";
import { BASE_URL } from "../Config";
import "./OverallImages.css";
import Sidebar from "../Components/Sidebar";
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import { MdClose } from "react-icons/md";
import { Header } from "antd/es/layout/layout";
const { Option } = Select;

const OverallImages = () => {
  const [images, setImages] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [roleFilter, setRoleFilter] = useState("all");
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth <= 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const LIMIT = 20;

  const fetchImages = async (pageNumber = 1, role = roleFilter) => {
    try {
      setLoading(true);

      const query = new URLSearchParams({
        page: pageNumber,
        limit: LIMIT,
      });

      if (role !== "all") {
        query.append("filter", role);
      }

      const res = await axios.get(
        `${BASE_URL}/global-images?${query.toString()}`,
      );

      if (res.data.success) {
        setImages(res.data.images);
        setTotal(res.data.total);
      }
    } catch (err) {
      console.error("Failed to load images");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchImages(page);
  }, [page, roleFilter]);

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}

        collapsedWidth="0"
        role="admin"
      />
      <Layout
        style={{
          marginLeft: isMobile ? 0 : collapsed ? 80 : 240,
          transition: "all 0.3s",
          padding: 20,
        }}
      >

        <Header
          className="MainHeader"
        >
          <Button
            type="text"
            icon={<HiOutlineMenuAlt2 size={22} />}
            onClick={() => setCollapsed(!collapsed)}
          />

          <h3 style={{ marginLeft: 10 }}>
            Overall Uploaded Images
          </h3>

        </Header>
        <Card style={{ margin: 20, borderRadius: 16 }}>
          <div className="overall-header">
            <h2>Overall Uploaded Images</h2>

            <Select
              value={roleFilter}
              style={{ width: 180 }}
              onChange={(value) => {
                setPage(1);
                setRoleFilter(value);
              }}
            >
              <Option value="all">All Images</Option>
              <Option value="admin">Admin Uploaded</Option>
              <Option value="user">User Uploaded</Option>
            </Select>
          </div>

          {loading ? (
            <div style={{ textAlign: "center", padding: 40 }}>
              <Spin size="large" />
            </div>
          ) : (
            <div className="image-grid">
              {images.map((img, index) => (
                <div className="image-card" key={index}>
                  <Image
                    src={img.url}
                    alt={img.title}
                    preview={{
                      mask: null, // ✅ removes "Preview" text & icon
                    }}
                    width="100%"
                    height={180}
                    style={{ objectFit: "cover" }}
                  />

                  <div className="image-overlay">
                    <div className="overlay-content">
                      <p className="image-title">{img.title}</p>
                      <span className="image-source">
                        {img.source} • {img.uploadedBy}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          <div style={{ textAlign: "center", marginTop: 30 }}>
            <Pagination
              current={page}
              total={total}
              pageSize={LIMIT}
              onChange={(p) => setPage(p)}
              showSizeChanger={false}
            />
          </div>
        </Card>
      </Layout>
    </Layout>
  );
};

export default OverallImages;
